export default __webpack_public_path__ + "static/media/app-promo@2x.a58fd2d7.png";